import React, { useEffect, useState } from "react";
import { download } from "react-icons-kit/fa/download";
import Button from "../../../components/Button";
import IconButton from "../../../components/IconButton";
import InputForm from "../../../components/InputForm";
import LabelForm from "../../../components/LabelForm";
import { donationsHf } from "../../../libs/services";

const InfoData = (props)=>{
    const {t} = props;
    const [disableLiberation, setLiberation] = useState(true);

    useEffect(()=>{
        var user_task = JSON.parse(sessionStorage.getItem("task_has_user_profiles"));
        user_task.forEach((user)=>{
            if(user !== undefined){
                if(user==='RELEASE_UNITS'){
                    setLiberation(false);
                }
            }
        });
    }, []);

    const generateDonationNumber = async ()=>{
        var id = props.match.params.id;
        var type = props.match.params.type;
        var hf_id = sessionStorage.getItem('health_facilities_id');

        var response;
        var obj = {
            offer_id: id
        };

        if(type === 'CELLS'){
            obj = {
                offering_cell_id: id
            };
        }

        response = await donationsHf(hf_id, obj, props.waiting);
        if(response){
            var element = {
                target:{
                    name:'donation_number',
                    value:response.donation_number
                }
            };
            props.handleChange(element, {type:''});

            element = {
                target:{
                    name:'donation_id',
                    value:response.id
                }
            };
            props.handleChange(element, {type:''});            

        }
    }
    

    return(
        <>
            <h4 className="theme-color">{props.person.fullName}</h4>

            <div className="col-xs-12 no-padding">
                <div className="col-xs-12 col-md-3">
                    <LabelForm text={t('content.modal_hc.birthday')} />
                    <InputForm 
                        id="birthday"
                        value={props.person.birthday}
                        handleChange={props.handleChange}
                        disabled
                    />                        
                </div>
                <div className="col-xs-12 col-md-1">	
                    <LabelForm text={t('content.modal_hc.age')} />
                    <InputForm 
                        id="age"
                        value={props.person.age}
                        handleChange={props.handleChange}
                        disabled
                    />
                </div>
                <div className="col-xs-12 col-md-2">
                    <LabelForm text={t('content.modal_hc.sex')} />
                    <InputForm 
                        id="sex"
                        value={props.person.sex}
                        handleChange={props.handleChange}
                        disabled
                    />
                </div>

                <div className="col-xs-12 col-md-3">
                    <LabelForm text="Tipo documento" />
                    <InputForm 
                        id="document_type"
                        value={props.person.document_type}
                        handleChange={props.handleChange}
                        disabled
                    />
                </div>
                <div className="col-xs-12 col-md-3">
                    <LabelForm text="No. documento" />
                    <InputForm 
                        id="document_number"
                        value={props.person.document_number}
                        handleChange={props.handleChange}
                        disabled
                    />
                </div>
            </div>

            <div className="col-xs-12 no-padding">                    
                <div className="col-xs-12 col-sm-4 col-md-4">
                    <LabelForm text={t('content.extractions.form.date')} />
                    <InputForm 
                        id="date"
                        value={props.person.date}
                        handleChange={props.handleChange}
                        disabled
                    />
                </div>

                <div className="col-xs-12 col-sm-5">
                    <LabelForm text={t('content.extractions.form.convoke_place')} />
                    <InputForm 
                        id="convokePlace"
                        value={props.person.convokePlace}
                        handleChange={props.handleChange}
                        disabled
                    />
                </div>
            </div>

            <div className="col-xs-12 form-group -no-padding">
                <div className="col-xs-9 col-sm-10 col-md-3" style={{paddingLeft:0}}>
                    <LabelForm text={t('content.extractions.form.donation_number')} />
                    <InputForm 
                        id="donation_number"
                        value={props.donation_number}
                        handleChange={props.handleChange}
                        disabled
                    />
                </div>

                <div className="col-xs-1 col-sm-1 col-md-1">
                    <IconButton 
                        class="btn-info btn-xs"
                        title="Generar Número de Donación"
                        disabled={props.task_extraction.create ? props.donation_number !== "" ? true : false : true}
                        icon={download}
                        action={generateDonationNumber}
                        styles={{marginTop:20, width:'100%'}}
                    />
                </div>

                <div className="col-xs-2 col-sm-2">
                    <Button 
                        class="btn-info"
                        disabled={disableLiberation ? disableLiberation : props.donation_number === "" ? true : false}
                        title="Liberar Número"
                        action={props.deleteNumber}
                        text="LIBERA NÚMERO"
                        styles={{marginTop:18, width:'100%'}}
                    />
                </div>
            </div>
        </>
    )
}

export default InfoData;